module.exports = "/images/ce2d82f4ab38ca8d864b7bc4938be54b.png";